"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ListIconButton = _interopRequireDefault(require("01_core/components/materials/ListIconButton"));
var _coreConfirmActions = require("01_core/reducers/coreConfirmActions");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _reactRedux = require("react-redux");
var _material = require("@mui/material");
var _styles = require("@mui/material/styles");
var _labelConsts = require("../../constants/labelConsts");
var _CButton = _interopRequireDefault(require("../materials/CButton"));
var _CDialog = _interopRequireDefault(require("../materials/CDialog"));
var _ResourceHtml = _interopRequireDefault(require("../materials/ResourceHtml"));
var _CodeUtil = require("../system/CodeUtil");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const DIALOG_MAX_WIDTH = 600;
const LIST_HEIGHT = 450;
const MOVE_BTN_HEIGHT = 30;
const DialogContainer = (0, _styles.styled)('div')(_ref => {
  let {
    theme
  } = _ref;
  return {
    maxWidth: DIALOG_MAX_WIDTH
  };
});
const ListPaper = (0, _styles.styled)(_material.Paper)(_ref2 => {
  let {
    theme
  } = _ref2;
  return {
    height: LIST_HEIGHT,
    overflowY: 'auto',
    overflowX: 'hidden',
    boxShadow: theme.shadows[3]
  };
});
const MoveButton = (0, _styles.styled)(_CButton.default)(_ref3 => {
  let {
    theme
  } = _ref3;
  return {
    height: MOVE_BTN_HEIGHT
  };
});
const DisplayName = (0, _styles.styled)('span')(_ref4 => {
  let {
    theme
  } = _ref4;
  return {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  };
});

/**
 * 並べ替え部品
 * @prop {string} items - 並べ替え対象リスト
 * @prop {string} items.displayName - 並べ替え対象の表示名
 * @prop {string} items.value - 並べ替え対象の値
 * @prop {func} onChange - 変更されたデータを受け取る関数
 * @prop {bool} noUpdate - 更新処理を行わない場合true、更新処理を行う場合false default:false
 * @prop {bool} isDispListIcon - ダイアログ呼び出しをボタンにする場合true、一覧で使用する更新アイコンにする場合false default:false
 * シグネチャ:({returnList:array}):void
 */
class SortUpdate extends _react.default.Component {
  constructor(props) {
    super(props);
    /** ダイアログ開く */
    _defineProperty(this, "openDialog", () => {
      const tgtList = this.props.items.slice(0, this.props.items.length);
      this.setState({
        isDialogOpen: true,
        selectObj: null,
        tgtList
      });
    });
    /** ダイアログ閉じる */
    _defineProperty(this, "closeDialog", () => {
      this.setState({
        isDialogOpen: false,
        tgtList: []
      });
    });
    _defineProperty(this, "onSortUpdateConfirm", () => {
      const {
        tgtList
      } = this.state;
      const {
        onChange
      } = this.props;
      const returnList = [];
      tgtList.forEach((item, index) => {
        returnList.push({
          key: item.value,
          sortOrder: index
        });
      });
      onChange(returnList);
      this.setState({
        isDialogOpen: false
      });
    });
    /** 更新ボタン押下 */
    _defineProperty(this, "clickUpdateBtn", () => {
      const {
        openConfirm,
        intl,
        noUpdate
      } = this.props;
      noUpdate ? this.onSortUpdateConfirm() : openConfirm(intl.formatMessage({
        id: _labelConsts.LABEL.CORE_CONFIRM
      }), /*#__PURE__*/_react.default.createElement(_ResourceHtml.default, {
        id: _labelConsts.LABEL.CORE_SORT_UPDATE_CONFIRM_MSG
      }), this.onSortUpdateConfirm);
    });
    /** 一番上へ移動 */
    _defineProperty(this, "moveToTop", obj => {
      if (obj && obj.index !== 0) {
        const tgtList = this.state.tgtList;
        tgtList.splice(obj.index, 1);
        tgtList.unshift(obj.data);
        this.setState({
          tgtList,
          selectObj: {
            data: obj.data,
            index: 0
          }
        });
      }
    });
    /** 一つ上へ移動 */
    _defineProperty(this, "moveUp", obj => {
      if (obj && obj.index !== 0) {
        const tgtList = this.state.tgtList;
        tgtList.splice(obj.index, 1);
        tgtList.splice(obj.index - 1, 0, obj.data);
        this.setState({
          tgtList,
          selectObj: {
            data: obj.data,
            index: obj.index - 1
          }
        });
      }
    });
    /** 一つ下へ移動 */
    _defineProperty(this, "moveDown", obj => {
      const tgtList = this.state.tgtList;
      if (obj && obj.index !== tgtList.length - 1) {
        tgtList.splice(obj.index, 1);
        tgtList.splice(obj.index + 1, 0, obj.data);
        this.setState({
          tgtList,
          selectObj: {
            data: obj.data,
            index: obj.index + 1
          }
        });
      }
    });
    /** 一番下へ移動 */
    _defineProperty(this, "moveToTail", obj => {
      const tgtList = this.state.tgtList;
      if (obj && obj.index !== tgtList.length - 1) {
        tgtList.splice(obj.index, 1);
        tgtList.push(obj.data);
        this.setState({
          tgtList,
          selectObj: {
            data: obj.data,
            index: tgtList.length - 1
          }
        });
      }
    });
    /** キャンセルボタン */
    _defineProperty(this, "cancelBtn", /*#__PURE__*/_react.default.createElement(_CButton.default, {
      autoWidth: true,
      negative: true,
      onClick: this.closeDialog
    }, this.props.intl.formatMessage({
      id: _labelConsts.LABEL.CORE_CANCEL
    })));
    /** 更新ボタン */
    _defineProperty(this, "updateBtn", /*#__PURE__*/_react.default.createElement(_CButton.default, {
      autoWidth: true,
      onClick: this.clickUpdateBtn
    }, this.props.intl.formatMessage({
      id: _labelConsts.LABEL.CORE_UPDATE
    })));
    this.state = {
      isDialogOpen: false,
      tgtList: [],
      selectObj: null
    };
  }
  render() {
    const {
      intl,
      isDispListIcon
    } = this.props;
    const {
      isDialogOpen,
      selectObj,
      tgtList
    } = this.state;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, isDispListIcon ? /*#__PURE__*/_react.default.createElement(_ListIconButton.default, {
      action: "update",
      onClick: this.openDialog
    }) : /*#__PURE__*/_react.default.createElement(_CButton.default, {
      autoWidth: true,
      onClick: this.openDialog
    }, intl.formatMessage({
      id: _labelConsts.LABEL.CORE_SORT_UPDATE
    })), /*#__PURE__*/_react.default.createElement(_CDialog.default, {
      open: isDialogOpen,
      title: intl.formatMessage({
        id: _labelConsts.LABEL.CORE_SORT_UPDATE
      }),
      handleClose: this.closeDialog,
      actions: [this.cancelBtn, this.updateBtn],
      width: "sm"
    }, /*#__PURE__*/_react.default.createElement(DialogContainer, null, /*#__PURE__*/_react.default.createElement(_material.DialogContent, null, /*#__PURE__*/_react.default.createElement(_material.Grid, {
      container: true,
      spacing: 2
    }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
      size: {
        xs: 12
      }
    }, /*#__PURE__*/_react.default.createElement(ListPaper, null, /*#__PURE__*/_react.default.createElement(_material.MenuList, null, tgtList.map((data, index) => {
      return /*#__PURE__*/_react.default.createElement(_material.MenuItem, {
        onClick: () => {
          this.setState({
            selectObj: {
              data,
              index
            }
          });
        },
        key: index,
        style: selectObj && selectObj.data.value === data.value ? {
          backgroundColor: '#169fc2'
        } : {
          backgroundColor: '#ffffff'
        }
      }, /*#__PURE__*/_react.default.createElement(DisplayName, null, data.displayName));
    })))), /*#__PURE__*/_react.default.createElement(_material.Grid, {
      size: {
        xs: 12
      },
      align: "center"
    }, /*#__PURE__*/_react.default.createElement(MoveButton, {
      autoWidth: true,
      negative: true,
      onClick: () => this.moveToTop(selectObj)
    }, intl.formatMessage({
      id: _labelConsts.LABEL.CORE_SORT_TOP
    })), /*#__PURE__*/_react.default.createElement(MoveButton, {
      autoWidth: true,
      negative: true,
      onClick: () => this.moveUp(selectObj)
    }, intl.formatMessage({
      id: _labelConsts.LABEL.CORE_SORT_UP
    })), /*#__PURE__*/_react.default.createElement(MoveButton, {
      autoWidth: true,
      negative: true,
      onClick: () => this.moveDown(selectObj)
    }, intl.formatMessage({
      id: _labelConsts.LABEL.CORE_SORT_DOWN
    })), /*#__PURE__*/_react.default.createElement(MoveButton, {
      autoWidth: true,
      negative: true,
      onClick: () => this.moveToTail(selectObj)
    }, intl.formatMessage({
      id: _labelConsts.LABEL.CORE_SORT_TAIL
    }))))))));
  }
}
SortUpdate.propTypes = {
  items: _propTypes.default.arrayOf(_propTypes.default.shape({
    displayName: _propTypes.default.string,
    value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
  })).isRequired,
  onChange: _propTypes.default.func.isRequired,
  noUpdate: _propTypes.default.bool,
  isDispListIcon: _propTypes.default.bool
};
SortUpdate.defaultProps = {
  noUpdate: false,
  isDispListIcon: false
};
const mapDispatchToProps = dispatch => ({
  openConfirm: (title, message, onClickOk) => dispatch(_coreConfirmActions.coreConfirmActions[_coreConfirmActions.TYPES_CONFIRM.OPEN](title, message, onClickOk))
});
var _default = exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)((0, _reactIntl.injectIntl)((0, _CodeUtil.withCodeUtil)(SortUpdate)));